import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-2021/uxp-photoshop-2021/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "join-the-community"
    }}>{`Join the community`}</h2>
    <p>{`Join the worldwide community of Creative Cloud Developers who are building plugins and integrations to empower creativity.`}</p>
    <p>{`Here are a few ways to get involved:`}</p>
    <ul>
      <li parentName="ul">{`Join the `}<a parentName="li" {...{
          "href": "https://forums.creativeclouddeveloper.com/"
        }}>{`Creative Cloud Developer Forums`}</a>{` to meet other developers, ask questions, and offer help`}</li>
      <li parentName="ul">{`Contribute issues and pull requests to our open source repos, including:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-photoshop"
            }}>{`UXP for Photoshop documentation repo on GitHub`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples"
            }}>{`UXP for Photoshop sample code repo on GitHub`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      